import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {LovValueSelectFilterComponent} from './lov-value-select-filter.component';
import {SelectFilterModule} from '../../../../../../../components/common/select-filter/select-filter.module';
import {ContentDirective} from '../../../../../../../shared/directives/content.directive';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SelectFilterModule,
    ],
    declarations: [
        LovValueSelectFilterComponent,
    ],
    exports: [
        LovValueSelectFilterComponent,
        ContentDirective,
    ],
})
export class LovValueSelectFilterModule {}
